import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "./UserPreferences.scss";
import checkOutlineLarge from "../../assets/images/check_outline_large.svg";
import Preferences from "../../models/preferences";

interface IProps {
    preferences: Preferences,
    close: () => void,
    savePreferences: (preferences: Preferences) => void,
    zoomLevels: Array<string>,
}

export default function UserPreferences(props: IProps) {
    const thumbnailCheck = useRef<HTMLInputElement>(null);
    const zoomSelect = useRef<HTMLSelectElement>(null);
    const bookmarksCheck = useRef<HTMLInputElement>(null);
    
    const [preferences, setPreferences] = useState<Preferences>(props.preferences);
    const [page, setPage] = useState<string>("pdfViewer");
    const [loading, setLoading] = useState<boolean>(false);
    
    async function onSavePrefs() {
        setLoading(true);
        props.savePreferences(preferences);
        props.close();
        setLoading(false);
    }
    
    return <Modal id="prefsModal" show={true}>
        <Modal.Title>
            User Preferences
        </Modal.Title>
        <Modal.Body>
            <div className="prefs-nav">
                <button
                    className={page == "pdfViewer" ? "active" : ""}
                    type="button"
                    onClick={() => setPage("pdfViewer")}
                >
                    PDF Viewer
                </button>
                {/* Uncomment to test multiple pages and scrolling. Delete when no longer needed. */}
                {/* <button
                    className={page == "test" ? "active" : ""}
                    type="button"
                    onClick={() => setPage("test")}
                >
                    Test Page
                </button> */}
            </div>
            <div className="prefs-body" hidden={page != "pdfViewer"}>
                <div className="check-container">
                    <input
                        id="thumbnailCheck"
                        type="checkbox"
                        name="showThumbnails"
                        ref={thumbnailCheck}
                        checked={preferences?.showThumbnails}
                        onChange={ev => {setPreferences({...preferences, showThumbnails: ev.target.checked})}}
                        disabled={loading}
                    ></input>
                    <label htmlFor="thumbnailCheck">
                        Thumbnails Visible
                    </label>
                </div>
                <div>
                    <label htmlFor="zoomLevel">
                        Zoom Level
                    </label>
                    <select
                        id="zoomLevel"
                        className="dropdown-Input dropdown-Input-style form-control"
                        name="zoomLevel"
                        ref={zoomSelect}
                        onChange={ev => {setPreferences({...preferences, zoomLevel: ev.target.value})}}
                        disabled={loading}
                    >
                        <option
                            hidden={true}
                            disabled={true}
                            value=""
                            selected={!preferences.zoomLevel}
                        />
                        {props.zoomLevels.map(x => <option
                            value={x}
                            selected={preferences.zoomLevel == x}
                        >
                            {x}
                        </option>)}
                    </select>
                </div>
                <div className="check-container">
                    <input
                        id="bookmarksCheck"
                        type="checkbox"
                        name="showBookmarks"
                        ref={bookmarksCheck}
                        checked={preferences?.showBookmarks}
                        onChange={ev => {setPreferences({...preferences, showBookmarks: ev.target.checked})}}
                        disabled={loading}
                    ></input>
                    <label htmlFor="bookmarksCheck">
                        Show Bookmarks
                    </label>
                </div>
            </div>
            {/* Delete this test page below and its commented button when adding another proper page */}
            <div className="prefs-body" hidden={page != "test"}>
                <span>Test page</span>
                <br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;
                <span>Long scrolling test</span>
                <br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;
                <span>More scrolling</span>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                className="btn"
                onClick={onSavePrefs}
                disabled={loading}
            >
                <img src={checkOutlineLarge}/>
                Save
            </button>
            <button
                type="button"
                className="cancel-button"
                onClick={props.close}
                disabled={loading}
            >
                Cancel
            </button>
        </Modal.Footer>
    </Modal>
}
